<template>
<div id="page-clientes">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Administrar Clientes" class="elevation-1 px-5 py-3">
          <v-card-actions>

            <v-spacer></v-spacer>
            <exportar-excel v-tippy style="cursor: pointer" title="Exportar" :data="datafiltered" :exportFields="clientes.camposexcel" name="Clientes.xlsx">
              <v-btn x-small fab dark color="success" title="Exportar" v-tippy>
                <v-icon dark>get_app</v-icon>
              </v-btn>
            </exportar-excel>
          </v-card-actions>
          <v-dialog v-model="modal" max-width="60%">
            <v-card>
              <v-card-title>
                <v-card class="primary white--text titulomodal">
                  <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>
                  <span class="subheading">
                    <strong>Actualizar Cliente</strong>
                  </span>
                </v-card>
              </v-card-title>
              <v-form ref="form" lazy-validation>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-row>
                      <v-col cols=6>
                        <v-text-field label="Nombre del Cliente" v-model="model.nombre" :rules="[rules.required]"></v-text-field>
                      </v-col>
                      <v-col cols=6>
                        <v-autocomplete :items="grupos" v-model="model.grupo" label="Grupo" item-text="nombre" item-value="id_grupo" clearable></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=3>
                        <v-text-field label="Año de recuperación" v-model="model.anio_recuperacion" :rules="[rules.required, rules.numeric]"></v-text-field>
                      </v-col>
                      <v-col cols=3>
                        <v-text-field label="Días permitidos de Consulta" v-model="model.dias_cliente" :rules="[rules.required, rules.numeric]"></v-text-field>
                      </v-col>
                      <v-col cols=3>
                        <v-autocomplete :items="tipos" v-model="model.tipos_empresa" label="Tipo Industria" item-text="nombre" item-value="id_tipo_empresa" :rules="[rules.required]"></v-autocomplete>
                      </v-col>
                      <v-col cols=3>
                        <v-autocomplete :items="tipos_servicio" v-model="model.tipo_servicio" label="Tipo Servicio" item-text="nombre" item-value="nombre" :rules="[rules.required]"></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=4>
                        <v-checkbox v-model="model.consultas_anteriores" :label="'Permitir Recuperaciones por Lista Años Anteriores'"></v-checkbox>
                      </v-col>
                      <v-col cols=4>
                        <v-checkbox v-model="model.niuko" :label="'Permitir conexión con API'" ></v-checkbox>
                      </v-col>
                      <v-col cols=4>
                        <v-checkbox v-model="model.limitado" :label="'Limitar recuperación Pedimentos y Partidas'"></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12>
                        <h5><b>E-Key: </b> {{ekey}}</h5>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 v-if="(model.niuko==1 && api_key!='')">
                        <h5><b>Key de Conexión con API: </b> {{api_key}}</h5>
                      </v-col>
                    </v-row>
                  
                    <!--  <v-row>
                                              <v-col cols=6>
                                                <v-checkbox v-model="model.guardar_peticiones" :label="'Guardar Peticiones'" ></v-checkbox>
                                              </v-col>
                                            </v-row> -->
                    <!--  <v-row>
                                            <v-col cols=6>
                                              <v-checkbox v-model="model.consultas_anteriores" :label="'Permitir Recuperaciones por Lista Años Anteriores'" ></v-checkbox>
                                            </v-col>
                                            </v-row> -->
                
                    <v-card-text>

                      <span class="primary--text">Módulos</span>
                      <v-data-table @item-selected="handleClick" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" hide-default-footer :items-per-page="20" dense :headers="modulos.headers" :items="modulos.items" class="elevation-1"
                        v-model="modulos.selected" item-key="id_modulo" show-select>
                        <template slot="items" slot-scope="modulos">
                          <tr>
                            <td>
                              <v-checkbox v-model="modulos.selected" primary hide-details></v-checkbox>
                            </td>
                            <td>{{ modulos.item.nombre }}</td>
                            <td>{{ getNombreSistema(modulos.item.sistema) }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-container>
                  <!-- <v-card-title v-if="false" >
                                        <span class="subheading primary--text" >Sistemas</span>
                                    </v-card-title>
                                    <v-card-text v-if="false" >
                                        <v-data-table :headers="sistemas.headers" :items="sistemas.items" class="elevation-1" v-model="sistemas.selected" item-key="id_sistema" >
                                            <template slot="items" slot-scope="sistemas" >
                                                <tr>
                                                    <td>
                                                        <v-checkbox v-model="sistemas.selected" primary hide-details @change="
                                filtrarModulos($event, sistemas.item.id_sistema)
                              " ></v-checkbox>
                                                    </td>
                                                    <td>{{ sistemas.item.nombre }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text> -->


                </v-card-text>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false">
                  <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="updateCliente()">
                  <v-icon>done</v-icon> Actualizar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-text>
            <div id="datagrid">

              <v-client-table ref="vuetable" :data="clientes.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="grupo" slot-scope="props">
                  <div v-if="props.row.grupo > 0">
                    {{ nombre_grupo(props.row.grupo) }}
                  </div>
                </template>
                <template slot="anio_recuperacion" slot-scope="props">
                  <div style="text-align:center">
                    {{ props.row.anio_recuperacion }}
                  </div>
                </template>

                <template slot="fecha_estatus" slot-scope="props">
                  <div style="text-align:center">
                    <v-btn x-small v-if="(props.row.fecha_estatus!=undefined && props.row.fecha_estatus!='')" outlined color="blue" @click="getCambiosEstatus(props.row.id_cliente, props.row.identificador)">
                      {{ props.row.fecha_estatus }}
                    </v-btn>                    
                  </div>
                </template>

                <template slot="dias_cliente" slot-scope="props">
                  <div style="text-align:center">
                    {{ props.row.dias_cliente }}
                  </div>
                </template>
                <template slot="estatus" slot-scope="props">
                  <div v-if="props.row.to_delete == 1" :style="'text-align:center;'">Por Eliminar</div>
                  <div v-else :style="'text-align:center;'">
                    <div v-if="props.row.estatus">Activo</div>
                    <div v-if="!props.row.estatus">Inactivo</div>
                  </div>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial direction="left" open-on-hover :style="'text-align:center;'">
                    <template v-slot:activator>
                      <v-btn x-small fab dark color="primary">

                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>
                    <v-btn x-small fab dark color="green" v-if="!props.row.estatus" @click.native="
                          changeEstatus(props.row.id_cliente, true, props.row.grupo)
                        " title="Activar Cliente" v-tippy>
                      <v-icon>check</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="orange" v-if="props.row.estatus" @click.native="
                          changeEstatus(props.row.id_cliente, false, props.row.grupo)
                        " title="Desactivar Cliente" v-tippy>
                      <v-icon>block</v-icon>
                    </v-btn>

                    <v-btn x-small fab dark color="blue" @click.native="getCliente(props.row.id_cliente)" title="Permisos" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn x-small fab dark color="pink" @click.native="deleteCliente(props.row.id_cliente)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>

  <v-dialog v-model="modal_estatus" max-width="45%">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon @click.native="modal_estatus = false" class="white--text">cancel</v-icon>
          <span class="subheading">
            <strong>Cambios de Estatus del Cliente: {{cliente_seleccionado}}</strong>
          </span>
        </v-card>
      </v-card-title>
        <v-client-table ref="vuetable" :data="data_estatus" :columns="columns_estatus" :options="options_estatus" class="elevation-2 pa-2">
            <template slot="noResults">
              <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
            </template>
        </v-client-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="modal_estatus = false">
          <v-icon small>cancel</v-icon> &nbsp;&nbsp;Cerrar
        </v-btn>        
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import objectRenameKeys from "object-rename-keys";
import moment from "moment"

export default {
  created: function() {
    this.getClientes();
    this.getTipos();
    this.getTiposServicios();
    this.getGrupos();
    this.getSistemas();
    this.getModulos();    
  },
  components: {},
  data() {
    return {
      api_key:"",
      cliente_seleccionado:"",
      modal_estatus:false,
      data_estatus:[],
      sortBy: 'nombre',
      ekey:"",
      sortDesc: false,
      fab: false,
      tipos: [],
      name: "datagrid",
      columns_estatus: ["fecha", "estatus_txt"],
      options_estatus:{
        filterable: ["fecha", "estatus_txt"],
        sortable: ["fecha", "estatus_txt"],
        headings:{
          "estatus_txt":"Estatus"
        }
      },
      columns: [
        "nombre",
        "identificador",
        "fecha_ingreso", "fecha_vencimiento",
        "tipo_industria", "ciudad", "estado",
        "grupo",
        "estatus", "fecha_estatus","tipo_servicio",
        "anio_recuperacion",
        "dias_cliente",
        "actions"
      ],
      show_loading: true,
      options: {
        filterable: ["nombre", "identificador", "fecha_ingreso", "fecha_vencimiento", "tipo_industria", "ciudad", "estado", "grupo", "estatus", "fecha_estatus", "tipo_servicio", "anio_recuperacion", "dias_cliente"],
        sortable: ["nombre", "identificador", "fecha_ingreso", "fecha_vencimiento", "tipo_industria", "ciudad", "estado", "grupo", "estatus", "fecha_estatus", "tipo_servicio", "dias_cliente"],

        headings: {
          nombre: "Nombre",
          identificador: "RFC o TAX ID",
          fecha_ingreso: "Fecha de Ingreso",
          fecha_vencimiento: "Fecha de Vencimiento",
          tipo_industria: "Tipo Industria",
          ciudad: "Ciudad",
          estado: "Estado",
          grupo: "Grupo",
          estatus: "Estatus",
          fecha_estatus: "Fecha de Actualización",
          "tipo_servicio":"Tipo de Servicio",
          anio_recuperacion: "Año de Recuperación",
          dias_cliente: "Días Consultas",
          actions: "Operaciones"
        },
        initFilters: {"estatus":'true'},
        listColumns: {
          grupo: [],
          estatus: [{
              id: true,
              text: "Activos"
            },
            {
              id: false,
              text: "Inactivos"
            },
            {
              id: null,
              text: "Todos"
            }
          ]
        }
      },
      show_loading: true,
      breadcrumbs: [{
          text: "Administración",
          disabled: false,
          to: "/admin"
        },
        {
          text: "Clientes",
          disabled: true,
          href: ""
        }
      ],
      grupos: [0],
      search: "",
      modal: false,
      pagination: {
        sortBy: "" //Orden por default
      },
      rules: {
        required: v => !!v || "Este campo es requerido",
        numeric: v => Number.isInteger(parseInt(v)) || "El campo debe ser un numero"
      },
      model: {
        id_cliente: "",
        nombre: "",
        grupo: "",
        sistemas: [],
        modulos: [],
        anio_recuperacion: 2012,
        tipos_empresa: "",
        tipo_servicio:"",
        guardar_peticiones: 0,
        consultas_anteriores: 0,
        dias_cliente: 30,
        niuko: 0,
        limitado: 0
      },

      tipos_servicio: [],
      clientes: {
        selected: [],
        items: [0],
        camposexcel: {
          Nombre: "nombre",
          RFC: "identificador",
          "Fecha de Ingreso": "fecha_ingreso",
          "Fecha de Vencimiento": "fecha_vencimiento",
          "Tipo Industria": "tipo_industria",
          "Ciudad": "ciudad",
          "Estado": "estado",
          Grupo: "grupo_nombre",
          Estatus: "estatus_nombre",
          "Fecha de Actualización": "fecha_estatus",
          "Tipo de Servicio":"tipo_servicio",
          "Año de Recuperación":"anio_recuperacion",
          "Días Consulta":"dias_cliente"
        },
      },
      sistemas: {
        selected: [],
        headers: [{
          text: "Nombre",
          value: "nombre"
        }],
        items: []
      },
      modulos: {
        selected: [],
        headers: [{
          text: "Nombre",
          value: "nombre",
          sortable: false,
        }, ],
        items: [],
        todos: []
      }
    };
  },
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.clientes.items;
      }
    },
  },

  methods: {
    nombre_grupo: function(id) {
      if (id) {
        let data = this.grupos.filter(item => item.id_grupo == id);
        if (data.length > 0) return data[0].nombre;
      }
    },
    handleClick(row) {
      console.log(row);
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    getClientes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .get(this.$hostname + "clientes/get_clientes/")        
        .then(response => {
          this.clientes.items = response.data;
          for (var k in this.clientes.items) {
            this.clientes.items[k].grupo_nombre = this.nombre_grupo(this.clientes.items[k].grupo);
            if (this.clientes.items[k].to_delete == 1 || this.clientes.items[k].to_delete == "1") {
              this.clientes.items[k].estatus_nombre = 'Por eliminar';
            } else {
              this.clientes.items[k].estatus_nombre = this.clientes.items[k].estatus == true ? 'Activo' : 'Inactivo';
            }
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los clientes.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getSistemas: function() {
      axios
        .get(this.$hostname + "sistemas/")
        .then(response => {
          this.sistemas.items = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los sistemas.",
            footer: ""
          });
        });
    },
    getModulos: function() {
      axios
        .post(this.$hostname + "clientes-sistemas/list_modulos/")
        .then(response => {
          this.modulos.items = response.data;
          this.modulos.todos = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los sistemas.",
            footer: ""
          });
        });
    },
    getCliente: function(id) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.model.sistemas = [];
      this.model.modulos = [];
      axios
        .get(this.$hostname + "clientes/" + id + "/")
        .then(response => {

          this.model.id_cliente = response.data.id_cliente;
          this.model.nombre = response.data.nombre;
          this.model.grupo = response.data.grupo;
          this.model.anio_recuperacion = response.data.anio_recuperacion;
          this.model.tipos_empresa = response.data.tipos_empresa;
          this.model.tipo_servicio = response.data.tipo_servicio;
          this.model.guardar_peticiones = response.data.guardar_peticiones;
          this.model.consultas_anteriores = response.data.consultas_anteriores;
          this.model.dias_cliente = response.data.dias_cliente;
          this.model.limitado = response.data.limitado;
          this.model.niuko = response.data.niuko;
          this.model.identificador = response.data.identificador;
          this.getSistemasCliente();
          this.ekey =  encodeURIComponent(this.$crypto.encrypted(this.model.identificador));
          this.getApiKey(id);
        })
        .catch(error => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el cliente",
            footer: ""
          });
        });
    },
    getGrupos: function() {
      axios
        .get(this.$hostname + "grupos/")
        .then(response => {
          this.grupos = response.data;
          let changesMap = {
            id_grupo: "id",
            nombre: "text"
          };
          this.options.listColumns.grupo = objectRenameKeys(
            response.data,
            changesMap
          );
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los grupos.",
            footer: ""
          });
        });
    },
    updateCliente: function() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        let id_cliente = this.model.id_cliente;
        let peticiones = 0;
        let anteriores = 0;
        let limitado = 0;
        let niuko = 0;

        if (this.model.guardar_peticiones == 1 || this.model.guardar_peticiones == "1" || this.model.guardar_peticiones == true) {
          peticiones = 1;
        }

        if (this.model.consultas_anteriores == 1 || this.model.consultas_anteriores == "1" || this.model.consultas_anteriores == true) {
          anteriores = 1;
        }

        if (this.model.limitado == 1 || this.model.limitado == "1" || this.model.limitado == true) {
          limitado = 1;
        }

        if (this.model.niuko == 1 || this.model.niuko == "1" || this.model.niuko == true) {
          niuko = 1;
        }

        let datos = {
          grupo: this.model.grupo,
          nombre: this.model.nombre,
          sistemas: this.model.sistemas,
          anio_recuperacion: this.model.anio_recuperacion,
          tipos_empresa: this.model.tipos_empresa,
          tipo_servicio: this.model.tipo_servicio,
          guardar_peticiones: peticiones,
          consultas_anteriores: anteriores,
          dias_cliente: this.model.dias_cliente,
          limitado: limitado,
          niuko: niuko,
          modulos: this.obtenerModulosSeleccionados()
        };

        axios
          .put(this.$hostname + "clientes/" + this.model.id_cliente + "/", datos)
          .then(response => {
            this.modal = false;

            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El Cliente se actualizó correctamente.",
              footer: ""
            });

            this.getClientes();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al obtener los grupos.",
              footer: ""
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
          });
      }
    },
    deleteCliente: function(id_cliente) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios
            .delete(this.$hostname + "clientes/" + id_cliente + "/", {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "cache-control": "no-cache"
            })
            .then(response => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: response.data.mensaje[0],
                footer: ""
              });

              this.getClientes();
            })
            .catch(error => {
              this.$root.$dialogLoader.hide();
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar al cliente",
                footer: ""
              });
            });
        }

      });
    },
    changeEstatus: function(id_cliente, estatus, grupo=null) {
      let texto = estatus ? "activar" : "desactivar";
      this.$swal({
        type: "info",
        title: "Confirme",
        text: "¿Está seguro de " + texto + " el cliente?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value){
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

          let data = {
            estatus: estatus,
            id_usuario: this.$local_storage.get("id_usuario"),
          };
          if(grupo!=null){
            data["grupo"] = grupo;
          }

          axios.put(
            this.$hostname + "clientes/" + id_cliente + "/", data)
          .then(response => {
            this.getClientes();
          }).catch(error => {
            console.log(error);
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al cambiar el estatus al cliente",
              footer: ""
            });
          });

        }
      });
    },
    openModal: function() {
      this.modal = true;
      this.sistemas.selected = [];
      this.modulos.selected = [];
      for (var i = this.sistemas.items.length - 1; i >= 0; i--) {
        if (this.model.sistemas.includes(this.sistemas.items[i].id_sistema)) {
          this.sistemas.selected.push(this.sistemas.items[i]);
        }
      }

      let filtrados = [];
      for (var i = this.sistemas.selected.length - 1; i >= 0; i--) {
        let mod = [];
        mod = this.modulos.todos.filter(item => {
          return this.sistemas.selected[i].id_sistema == item.sistema;
        });

        for (var j = mod.length - 1; j >= 0; j--) {
          filtrados.push(mod[j]);
        }
      }

      this.modulos.items = filtrados;

      for (var i = this.modulos.items.length - 1; i >= 0; i--) {
        if (this.model.modulos.includes(this.modulos.items[i].id_modulo)) {
          this.modulos.selected.push(this.modulos.items[i]);
        }
      }
    },

    getSistemasCliente: function() {
      axios
        .get(this.$hostname + "clientes-sistemas/")
        .then(response => {
          let datos = response.data.filter(item => {
            return this.model.id_cliente == item.cliente;
          });

          for (var i = datos.length - 1; i >= 0; i--) {
            this.model.sistemas.push(datos[i].sistema);
          }

          this.getModulosCliente();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los sistemas del cliente.",
            footer: ""
          });
          this.$root.$dialogLoader.hide();
        });
    },
    getModulosCliente: function() {
      axios
        .post(this.$hostname + "clientes-sistemas/list_modulos_cliente/", {
          cliente: this.model.id_cliente
        })
        .then(response => {
          let datos = response.data;
          for (var i = datos.length - 1; i >= 0; i--) {
            this.model.modulos.push(datos[i].modulo);
          }

          this.openModal();
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los modulos del cliente.",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    filtrarModulos: function(evt, id_sistema) {
      if (evt) {
        let datos = this.modulos.todos.filter(item => {
          return item.sistema == id_sistema;
        });

        for (var i = datos.length - 1; i >= 0; i--) {
          this.modulos.items.push(datos[i]);
          this.model.sistemas = [];
          for (var j = this.sistemas.selected.length - 1; j >= 0; j--) {
            this.model.sistemas.push(this.sistemas.selected[j].id_sistema);
          }
        }
      } else {
        let datos = this.modulos.items.filter(item => {
          return item.sistema != id_sistema;
        });
        this.modulos.items = datos;
        this.model.sistemas = [];
        for (var i = this.sistemas.selected.length - 1; i >= 0; i--) {
          this.model.sistemas.push(this.sistemas.selected[i].id_sistema);
        }

        let quitar = this.modulos.todos.filter(item => {
          return item.sistema == id_sistema;
        });
        for (var i = quitar.length - 1; i >= 0; i--) {
          if (this.model.modulos.includes(quitar[i].id_modulo)) {
            this.model.modulos = this.model.modulos.slice(quitar[i].id_modulo);
          }
        }

        this.modulos.selected = this.modulos.selected.filter(item => {
          return item.sistema != id_sistema;
        });
      }
    },
    obtenerModulosSeleccionados: function() {
      let datos = [];
      for (var i = this.modulos.selected.length - 1; i >= 0; i--) {
        datos.push(this.modulos.selected[i].id_modulo);
      }

      return datos;
    },
    getNombreSistema: function(id_sistema) {
      let nombre;

      nombre = this.sistemas.items.filter(item => {
        return item.id_sistema == id_sistema;
      });
      if (nombre.length > 0) return nombre[0].nombre;
      else return "";
    },
    getTipos: function() {
      axios.get(this.$hostname + "catalogos/tipos_empresas/get_tipos/")
        .then(response => {
          this.tipos = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos.",
            footer: ""
          });
        });
    },
    getTiposServicios: function() {
      axios.get(this.$hostname + "catalogos/tipos_servicios/get_tipos/")
        .then(response => {
          this.tipos_servicio = response.data;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de servicios.",
            footer: ""
          });
        });
    },
    getCambiosEstatus: function(id_cliente, cliente){
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      axios.post(this.$hostname + "clientes/get_log_estatus_cliente/",{"id_cliente":id_cliente})      
        .then(response => {
          this.data_estatus = response.data;

          this.data_estatus.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha) ;
            });

          for(var k in this.data_estatus){
            this.data_estatus[k]["fecha"] = moment(this.data_estatus[k]["fecha"]).format('YYYY-MM-DD HH:mm:ss');
            var txt = "Inactivada por usuario ("+this.data_estatus[k]["iniciales"]+")";
            if (this.data_estatus[k]["estatus"] == 1){
              txt = "Activada por usuario ("+this.data_estatus[k]["iniciales"]+")";
            }
            this.data_estatus[k]["estatus_txt"] = txt;
          }
          this.cliente_seleccionado = cliente;
          this.modal_estatus = true;
          
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener log de cambio de estatus. Intente nuevamente.",
            footer: ""
          });
        }).then(()=>{
          this.$root.$dialogLoader.hide();
        });
    },
    getApiKey: function(id_cliente){
      axios.post(this.$apiReportes + "api/get_api_key/",{"id_cliente":id_cliente})      
        .then(response => {
          this.api_key = response.data["api_key"];          
        })
        .catch(error => {
          console.log("Error ApiKey: ", error);
          this.api_key = "";
        });
    },
  }
};
</script>
